import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/branding/centrallize-mark-ui.jpg'


const _withScopeId = n => (_pushScopeId("data-v-611974c9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sidebar-menu" }
const _hoisted_2 = { class: "logo position-absolute start-0 end-0 top-0 bg-black division-company-name" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Símbolo da Centrallize",
  width: "34"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "company-name fw-bold ms-10 fs-16" }, "Centrallize", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bb-2" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ph ph-x" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  class: "sidebar-navbar-nav ps-0 mb-0 list-unstyled accordion",
  id: "sidebarNavAccordion"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-pie-chart-1" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Dashboard", -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-calendar" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Calendário", -1))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-book" }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Agendamentos", -1))
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-chat" }, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Conversas", -1))
const _hoisted_20 = {
  key: 0,
  class: "new-badge fw-medium d-inline-block"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ph ph-megaphone" }, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Campanhas WhatsApp", -1))
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-people" }, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Clientes", -1))
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-bar-chart-2" }, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Performance", -1))
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-shopping-cart-2" }, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Vendas", -1))
const _hoisted_32 = [
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-3d-cube" }, null, -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Produtos", -1))
const _hoisted_35 = [
  _hoisted_33,
  _hoisted_34
]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-money" }, null, -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Financeiro", -1))
const _hoisted_38 = [
  _hoisted_36,
  _hoisted_37
]
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-setting" }, null, -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Configurações", -1))
const _hoisted_41 = [
  _hoisted_39,
  _hoisted_40
]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-credit-card" }, null, -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Pagamentos", -1))
const _hoisted_44 = [
  _hoisted_42,
  _hoisted_43
]
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block support-menu-button"
}, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "ph ph-whatsapp-logo" }),
    /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Suporte")
  ])
], -1))
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = {
  key: 1,
  id: "mobile-more-menu",
  class: "mobile-more-menu"
}
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ph ph-whatsapp-logo" }, null, -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Suporte", -1))
const _hoisted_50 = [
  _hoisted_48,
  _hoisted_49
]
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-logout" }, null, -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Deslogar", -1))
const _hoisted_53 = [
  _hoisted_51,
  _hoisted_52
]
const _hoisted_54 = { class: "mobile-bottom-icon" }
const _hoisted_55 = {
  key: 0,
  class: "mobile-new-badge"
}
const _hoisted_56 = { class: "mobile-bottom-label" }
const _hoisted_57 = ["aria-expanded"]
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mobile-bottom-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-menu-3" })
], -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mobile-bottom-label" }, "Ver mais", -1))
const _hoisted_60 = [
  _hoisted_58,
  _hoisted_59
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass([
      'sidebar-area position-fixed start-0 top-0 bg-black h-100vh transition',
      { active: _ctx.stateStoreInstance.open, 'attendants-day-sidebar': _ctx.isScheduleActive },
    ]),
      id: "sidebar-area"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _hoisted_5,
          _createElementVNode("button", {
            class: "sidebar-burger-menu position-absolute lh-1 bg-transparent p-0 border-0",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args)))
          }, _hoisted_7)
        ]),
        _createElementVNode("ul", _hoisted_8, [
          (_ctx.canAccessPage('dashboard'))
            ? (_openBlock(), _createElementBlock("li", {
                key: 0,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args))),
                class: "dashboard sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
              }, [
                _createVNode(_component_router_link, {
                  to: "/dashboard",
                  class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: _normalizeClass({ active: _ctx.isDashboardActive })
                    }, _hoisted_11, 2)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.canAccessPage('calendar'))
            ? (_openBlock(), _createElementBlock("li", {
                key: 1,
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args))),
                class: "dashboard sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
              }, [
                _createVNode(_component_router_link, {
                  to: "/calendar",
                  class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: _normalizeClass({ active: _ctx.isCalendarActive })
                    }, _hoisted_14, 2)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.canAccessPage('attendants-day'))
            ? (_openBlock(), _createElementBlock("li", {
                key: 2,
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args))),
                class: "dashboard sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
              }, [
                _createVNode(_component_router_link, {
                  to: "/attendants-day",
                  class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: _normalizeClass({ active: _ctx.isScheduleActive })
                    }, _hoisted_17, 2)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.canAccessPage('chat'))
            ? (_openBlock(), _createElementBlock("li", {
                key: 3,
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args))),
                class: "realtime sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
              }, [
                _createVNode(_component_router_link, {
                  to: "/chat",
                  class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: _normalizeClass({ active: _ctx.isChatActive })
                    }, [
                      _hoisted_18,
                      _hoisted_19,
                      (_ctx.getPendingMessagesChat.length > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.getPendingMessagesChat.length), 1))
                        : _createCommentVNode("", true)
                    ], 2)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.canAccessPage('whatsapp-campaigns'))
            ? (_openBlock(), _createElementBlock("li", {
                key: 4,
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args))),
                class: "sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
              }, [
                _createVNode(_component_router_link, {
                  to: "/whatsapp-campaigns",
                  class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: _normalizeClass({ active: _ctx.$route.path === '/whatsapp-campaigns' })
                    }, _hoisted_23, 2)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.canAccessPage('clients'))
            ? (_openBlock(), _createElementBlock("li", {
                key: 5,
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args))),
                class: "documentacao performance sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
              }, [
                _createVNode(_component_router_link, {
                  to: "/clients",
                  class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: _normalizeClass({ active: _ctx.isClientsActive })
                    }, _hoisted_26, 2)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.canAccessPage('performance'))
            ? (_openBlock(), _createElementBlock("li", {
                key: 6,
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args))),
                class: "documentacao performance sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
              }, [
                _createVNode(_component_router_link, {
                  to: "/performance",
                  class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: _normalizeClass({ active: _ctx.isPerformanceActive })
                    }, _hoisted_29, 2)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.canAccessPage('sales'))
            ? (_openBlock(), _createElementBlock("li", {
                key: 7,
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args))),
                class: "documentacao performance sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
              }, [
                _createVNode(_component_router_link, {
                  to: "/sales",
                  class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: _normalizeClass({ active: _ctx.isSalesActive })
                    }, _hoisted_32, 2)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.canAccessPage('products'))
            ? (_openBlock(), _createElementBlock("li", {
                key: 8,
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args))),
                class: "documentacao performance sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
              }, [
                _createVNode(_component_router_link, {
                  to: "/products",
                  class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: _normalizeClass({ active: _ctx.isProductsActive })
                    }, _hoisted_35, 2)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.canAccessPage('financial-management'))
            ? (_openBlock(), _createElementBlock("li", {
                key: 9,
                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args))),
                class: "documentacao performance sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
              }, [
                _createVNode(_component_router_link, {
                  to: "/financial-management",
                  class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: _normalizeClass({ active: _ctx.isFinancialManagementActive })
                    }, _hoisted_38, 2)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.canAccessPage('configurations'))
            ? (_openBlock(), _createElementBlock("li", {
                key: 10,
                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args))),
                class: "documentacao performance sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
              }, [
                _createVNode(_component_router_link, {
                  to: "/configurations",
                  class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: _normalizeClass({ active: _ctx.isConfigurationActive })
                    }, _hoisted_41, 2)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.canAccessPage('payment'))
            ? (_openBlock(), _createElementBlock("li", {
                key: 11,
                onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args))),
                class: "pagamentos performance sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
              }, [
                _createVNode(_component_router_link, {
                  to: "/payment",
                  class: "accordion-button collapsed rounded-0 shadow-none bg-transparent d-block"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: _normalizeClass({ active: _ctx.isPaymentActive })
                    }, _hoisted_44, 2)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("li", {
            onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.openSupportWhatsapp && _ctx.openSupportWhatsapp(...args))),
            class: "pagamentos performance sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
          }, _hoisted_46)
        ])
      ])
    ], 2),
    (_ctx.mobileVisibleItems.length > 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["mobile-bottom-menu", { 'more-open': _ctx.mobileMoreOpen }])
        }, [
          (_ctx.mobileMoreOpen)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "mobile-more-backdrop",
                type: "button",
                "aria-label": "Fechar menu",
                onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.closeMobileMore && _ctx.closeMobileMore(...args)))
              }))
            : _createCommentVNode("", true),
          (_ctx.mobileMoreOpen)
            ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mobileMoreItems, (item) => {
                  return (_openBlock(), _createBlock(_component_router_link, {
                    key: item.key,
                    to: _ctx.mobileMenuTarget(item),
                    class: _normalizeClass(["mobile-more-link", { active: _ctx.isMobileItemActive(item) }]),
                    onClick: _ctx.closeMobileMore
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("i", {
                        class: _normalizeClass(item.icon)
                      }, null, 2),
                      _createElementVNode("span", null, _toDisplayString(item.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["to", "class", "onClick"]))
                }), 128)),
                _createElementVNode("button", {
                  class: "mobile-more-link mobile-more-action",
                  type: "button",
                  onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.openSupportWhatsapp && _ctx.openSupportWhatsapp(...args)))
                }, _hoisted_50),
                _createElementVNode("button", {
                  class: "mobile-more-link mobile-more-action",
                  type: "button",
                  onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.toggleDarkMode && _ctx.toggleDarkMode(...args)))
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass(_ctx.isDarkMode ? 'flaticon-sun' : 'flaticon-moon')
                  }, null, 2),
                  _createElementVNode("span", null, _toDisplayString(_ctx.isDarkMode ? 'Modo claro' : 'Modo escuro'), 1)
                ]),
                _createElementVNode("button", {
                  class: "mobile-more-link mobile-more-action mobile-logout-action",
                  type: "button",
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#verticallyCenteredModal",
                  onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.closeMobileMore && _ctx.closeMobileMore(...args)))
                }, _hoisted_53)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("nav", {
            class: "mobile-bottom-nav",
            style: _normalizeStyle({ gridTemplateColumns: `repeat(${_ctx.mobileBottomItemCount}, minmax(0, 1fr))` }),
            "aria-label": "Menu principal mobile"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mobilePrimaryItems, (item) => {
              return (_openBlock(), _createBlock(_component_router_link, {
                key: item.key,
                to: _ctx.mobileMenuTarget(item),
                class: _normalizeClass(["mobile-bottom-link", { active: _ctx.isMobileItemActive(item) }]),
                onClick: _ctx.closeMobileMore
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_54, [
                    _createElementVNode("i", {
                      class: _normalizeClass(item.icon)
                    }, null, 2),
                    (item.key === 'chat' && _ctx.getPendingMessagesChat.length > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_55, _toDisplayString(_ctx.getPendingMessagesChat.length), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("span", _hoisted_56, _toDisplayString(item.label), 1)
                ]),
                _: 2
              }, 1032, ["to", "class", "onClick"]))
            }), 128)),
            _createElementVNode("button", {
              class: _normalizeClass(["mobile-bottom-link mobile-more-button", { active: _ctx.mobileMoreOpen || _ctx.isMoreItemActive }]),
              type: "button",
              "aria-expanded": _ctx.mobileMoreOpen ? 'true' : 'false',
              "aria-controls": "mobile-more-menu",
              onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.toggleMobileMore && _ctx.toggleMobileMore(...args)))
            }, _hoisted_60, 10, _hoisted_57)
          ], 4)
        ], 2))
      : _createCommentVNode("", true)
  ], 64))
}